<template>
  <GwMenu
    placement="bottom-start "
    :flOptions="{ offset: 0, padding: 0 }"
    class="w-100"
    :ignoreDataGwmenu="true"
    @open="handleOpen"
  >
    <template #opener>
      <div
        style="--btn-back-inset: 0 auto auto -0.25rem; --btn-back-width: calc(100% + 0.5rem)"
        class="gw_btn_hover_back w-100"
      >
        <slot name="text"></slot>
      </div>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu"
        style="padding: 0.5rem"
        data-gwmenu="noclose"
      >
        <div
          class="gw_input_wrapper"
          style="--input-height: 2rem; --input-border-width: 1px"
          :class="{ gw_input_error: l_text.length > 128 }"
        >
          <input
            ref="input"
            autofocus
            contenteditable="true"
            :value="l_text"
            class="textarea_note"
            @input="e => (l_text = e.target.value)"
            @keydown.stop.enter.exact.prevent="
              () => {
                $emit('confirm', l_text)
                methods.toggleOpen(false)
              }
            "
          />
          <div class="gw_input_error_message">
            {{
              $t(`messages.field_name_too_many_characters`, {
                max_chars: 128,
              })
            }}
          </div>
        </div>

        <div class="d-flex mt-2">
          <div
            class="gw_btn weight_500 ml-auto"
            @click="methods.toggleOpen(false)"
          >
            {{ $t('btn.close') }}
          </div>
          <div
            class="gw_btn gw_btn_primary weight_500 ml-2"
            :class="{ 'gw_btn_disabled no-events': l_text.length > 128 }"
            style="--clr-disabled: var(--clr-grey-2)"
            @click="
              () => {
                $emit('confirm', l_text)
                methods.toggleOpen(false)
              }
            "
          >
            {{ $t('btn.confirm') }}
          </div>
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import { nextTick } from 'vue'
import GwMenu from '@/components/lib/GwMenu'

// TODO - add optional blank validation
export default {
  name: 'GwTableInputMenu',
  components: {
    GwMenu,
  },
  props: {
    text: { required: true, type: String },
  },
  emits: ['confirm'],
  data() {
    return {
      l_text: '',
    }
  },
  methods: {
    handleOpen() {
      this.l_text = this.text
      nextTick(() => {
        if (this.$refs.input) this.$refs.input.focus()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.savedfiltersmenu {
  --btn-height: 1.75rem;
}
</style>
